<script setup lang="ts">
import { inject, reactive, type Ref } from 'vue';
import type { Tutorial } from '@/services/api/emsl';

interface DialogRefValue {
  data?: { item?: Tutorial };
}

const dialogRef = inject<Ref<DialogRefValue | undefined>>('dialogRef');
const emit = defineEmits<{ (e: 'close', data?: unknown): void }>();

const item = dialogRef?.value?.data?.item;

const form = reactive({ topic: item?.topic ?? '', link: item?.link ?? '' });

function submit(): void {
  if (!form.topic || !form.link) return;
  emit('close', { ...form });
}
</script>

<template>
  <form class="tut-dialog" @submit.prevent="submit">
    <div class="tut-dialog__field">
      <label for="tut-topic">Topic</label>
      <input id="tut-topic" v-model="form.topic" type="text" required autofocus />
    </div>
    <div class="tut-dialog__field">
      <label for="tut-link">URL</label>
      <input id="tut-link" v-model="form.link" type="url" required placeholder="https://" />
    </div>
    <div class="tut-dialog__actions">
      <button type="submit">Save</button>
      <button type="button" @click="emit('close')">Cancel</button>
    </div>
  </form>
</template>

<style scoped>
.tut-dialog {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.25rem 0 0.5rem;
  min-width: 24rem;
}
.tut-dialog__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.tut-dialog__field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}
.tut-dialog__field input {
  padding: 0.4rem 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font: inherit;
}
.tut-dialog__actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}
</style>
